import React, { useState, useEffect } from "react";
import TutorialsContext, {
  defaultTutorialsState
} from "../../../context/TutorialsContext";
import { useQuery, useMutation } from "@apollo/react-hooks";
import { GetTutorials } from "./queries";
import { CompleteTutorial } from "./mutations";
import useAuthState from "../../../hooks/useAuthState";
import { Belt } from "../../../layouts/Belt";
import { Spinner } from "@blueprintjs/core";

function Tutorials({ children }) {
  const [tutorialsState, setTutorialsState] = useState(defaultTutorialsState);
  
  const { isLoggedIn } = useAuthState();
  const { data, loading: queryLoading } = useQuery(GetTutorials);
  
  const [completeTutorial] = useMutation(CompleteTutorial, {
    refetchQueries: [{ query: GetTutorials }],
    awaitRefetchQueries: true
  });

  useEffect(() => {
    if (isLoggedIn && queryLoading) {
      setTutorialsState({
        loading: true,
        tutorials: undefined,
        hasCompletedOnboarding: false,
        isNmiAccount: false,
        getHasCompletedTutorial: () => false,
        completeTutorial: () => {}
      });
    } else if (
      data &&
      data.accounts &&
      data.accounts.length &&
      data.accounts[0].tutorials
    ) {
      const tutorials = data.accounts[0].tutorials;
      const { isNmiAccount } = data.accounts[0];
      const getHasCompletedTutorial = (name, version = 1) => {
        return tutorials.find(
          (tutorial) => tutorial.name === name && tutorial.version === version
        );
      };

      const hasCompletedOnboarding =
        getHasCompletedTutorial("Brand Dashboard Personal Info") &&
        getHasCompletedTutorial("Brand Dashboard Organization Info") &&
        getHasCompletedTutorial("Brand Dashboard Payment Info");

      setTutorialsState({
        loading: false,
        tutorials,
        hasCompletedOnboarding,
        isNmiAccount,
        getHasCompletedTutorial,
        completeTutorial
      });
    } else if (!isLoggedIn) {
      setTutorialsState({
        loading: false,
        tutorials: undefined,
        hasCompletedOnboarding: false,
        getHasCompletedTutorial: () => false,
        completeTutorial: () => {}
      });
    }
  }, [data, isLoggedIn]);
  return (
    <TutorialsContext.Provider value={tutorialsState}>
      {
        tutorialsState.loading ? (
          <div className="loadingContainer">
            <Belt centered width={300}>
              <Spinner />
            </Belt>
          </div>
        ):
          children
      }
    </TutorialsContext.Provider>
  );
}

export default Tutorials;
